import { Link } from 'react-admin';
import PlusIcon from '@mui/icons-material/Add';
import { makeStyles } from '@mui/styles';

import { BlueOutlineButton, InitialCard } from '@components';

const EditBtn = () => (
  <Link to={'/finance-cost-type/1'}>
    <BlueOutlineButton size="small">
      <PlusIcon /> Edit elements
    </BlueOutlineButton>
  </Link>
);

export const FinanceCostTypes = ({ costTypes }: {costTypes: any[]}) => {
  const cls = useStyles();

  return (
    <InitialCard left="Cost Types" extraPadding mt={20}>
      <div className={cls.line}>
        <div>
          <span className={cls.label}>Type options:</span>
          <span>{costTypes.length} Elements</span>
        </div>
        <div>
          <EditBtn />
        </div>
      </div>
    </InitialCard>
  );
};

const useStyles = makeStyles({
  line: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    fontSize: 18,
    fontWeight: 400,
  },
  label: {
    color: 'var(--primary-color)',
    marginRight: 18,
  },
});
